import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// import Layout from '@/layouts/Layout'
import ContentView from '@/layouts/ContentView'
import Util from '@/common/utils/Util'
import ConstCode from '@/common/constants/ConstCode'
import AccountSvc from '@/common/service/AccountSvc'

/**
 * 페이지
 */
import Login from '@/pages/account/login'
import FindID from '@/pages/account/findID'
import FindPWD from '@/pages/account/findPWD'
import JoinStep from '@/pages/account/joinStep'
import JoinComplete from '@/pages/account/joinComplete'
import Wait from '@/pages/account/wait'
import Home from '@/pages/main/home'
import Case from '@/pages/main/case'
import Select from '@/pages/main/select'
import Progress from '@/pages/main/progress'
import Report from '@/pages/main/report'
import ReportDetail from '@/pages/main/reportDetail'
import ReportDetailLow from '@/pages/main/reportDetailLow'
import ReportUser from '@/pages/main/reportUser'
import ReportSummary from '@/pages/main/reportSummary'
import Message from '@/pages/main/message'
// import Receipt from '@/pages/main/receipt'
import PushLog from '@/pages/mypage/pushLog'

import IntroInquire from '@/pages/account/inquire'

import Mypage from '@/pages/mypage/index'
import Notice from '@/pages/mypage/notice'
import NoticeDetail from '@/pages/mypage/noticeDetail'
import Faq from '@/pages/mypage/faq'
import Inquire from '@/pages/mypage/inquire'
import InquireDetail from '@/pages/mypage/inquireDetail'
import InquireForm from '@/pages/mypage/inquireForm'
import ModifyCompany from '@/pages/mypage/modifyCompany'
import ModifyContact from '@/pages/mypage/modifyContact'
import ModifyPWD from '@/pages/mypage/modifyPWD'
import ModifyAddress from '@/pages/mypage/modifyAddress'

import Cert from '@/pages/cert/index'
import Lab from '@/pages/lab/index'
import LabResearchList from '@/pages/lab/researchList'
import LabRequestResearch from '@/pages/lab/requestResearch'
import LabRequestChange from '@/pages/lab/requestChange'
import LabRequestPerformance from '@/pages/lab/requestPerformance'

import ElectSelectUser from '@/pages/elect/select'

Vue.use(Router)

/**
 * header, footer와 같은 layout 상태 update
 * @param meta.isFooter {Boolean} footer show 여부
 * @param meta.isHeader {Boolean} header show 여부
 * @param meta.titleName {String} header title String
 * @param meta.isMain {Boolean} main header show 여부
 *
 * */
const updateLayout = (meta) => {
  store.commit('layout/setLayout', {
    titleName: meta.titleName,
    isHeader: meta.isHeader,
    isFooter: meta.isFooter,
    isMain: meta.isMain,
    headerIconType: meta.headerIconType,
    isTab: meta.isTab,
    tabType: meta.tabType,
    isMypage: meta.isMypage
  })
}

let nowPath = ''
// let closePaths = ['/', '/account/login', '/account/wait', '/main/home', '/main/report', '/main/reportUser', '/mypage']
let closePaths = ['/', '/account/login', '/account/wait', '/main/home']

const router = new Router({
  linkActiveClass: 'on',
  mode: 'history',
  // scrollBehavior,
  routes: [
    {
      path: '/comm',
      component: ContentView,
      children: [
        {
          path: '/comm/privacy',
          component: () => import('@/pages/comm/privacy.vue'),
          meta: {
            titleName: '개인정보 처리방침'
          }
        },
        {
          path: '/comm/terms',
          component: () => import('@/pages/comm/terms.vue'),
          meta: {
            titleName: '이용약관'
          }
        },
        {
          path: '/comm/inquire',
          component: () => import('@/pages/comm/inquire.vue'),
          meta: {
            titleName: '문의하기'
          }
        }
      ]
    },
    {
      path: '/',
      component: ContentView,
      redirect: '/account/login',
      beforeEnter: async function (to, from, next) {
        if (to.path === '/' || to.path === '/account/login') {
          if (Util.isApp()) {
            // 푸시정보 업데이트
            Util.nativeGetRegistrationKey('nativeSetDeviceInfo')
          }
          const res = await AccountSvc.refreshUserData()
          const code = res.code
          const userInfo = res.entity

          if (code === 1) {
            // 승인 전
            if (userInfo.userStatus === 99) {
              return next('/account/wait')
            }
            // 승인 후
            else {
              // 전력비 중간관리자인 경우
              if (userInfo.userType === 2) {
                return next('/elect/select')
              }
              // 일반회원인 경우
              else {
                return next('/main/home')
              }
            }
          }
        } else {
          const userData = store.getters['account/getUserData']
          if (Util.isEmpty(userData)) {
            return next('/account/login')
          }
        }

        return next()
      },
      children: [
        {
          path: '/account/login',
          name: 'account-login',
          component: Login,
          meta: {isMain: false, isHeader: false, isFooter: false}
        },
        {
          path: '/account/findID',
          name: 'account-findID',
          component: FindID,
          meta: {isMain: false, isHeader: true, isTab: true, tabType: ConstCode.TAB_TYPE.FINDID, isFooter: false, titleName: '계정 찾기'}
        },
        {
          path: '/account/findPWD',
          name: 'account-findPWD',
          component: FindPWD,
          meta: {isMain: false, isHeader: true, isTab: true, tabType: ConstCode.TAB_TYPE.FINDPWD, isFooter: false, titleName: '계정 찾기'}
        },
        {
          path: '/account/joinStep',
          name: 'account-joinStep',
          component: JoinStep,
          meta: {isMain: false, isHeader: true, isFooter: false, titleName: '회원 가입'}
        },
        {
          path: '/account/joinComplete',
          name: 'account-joinComplete',
          component: JoinComplete,
          meta: {isMain: false, isHeader: true, isFooter: false, titleName: '회원 가입 신청 완료'}
        },
        {
          path: '/account/wait',
          name: 'comm-wait',
          component: Wait,
          meta: {isMain: false, isHeader: true, isFooter: false, headerIconType: ConstCode.HEADER_ICON_TYPE.LOGOUT}
        },
        {
          path: '/main/home',
          name: 'main-home',
          component: Home,
          meta: {isMain: true, isHeader: true, isFooter: true}
        },
        {
          path: '/main/case',
          name: 'main-case',
          component: Case,
          meta: {isMain: false, isHeader: true, titleName: '고객사례', isFooter: true}
        },
        {
          path: '/main/select',
          name: 'main-select',
          component: Select,
          meta: {isMain: true, isHeader: true, isFooter: true}
        },
        {
          path: '/main/progress',
          name: 'main-progress',
          component: Progress,
          // meta: {isMain: true, isHeader: true, isFooter: true}
          meta: {isMain: false, isHeader: true, titleName: '전력비 절감 서비스'}
        },
        {
          path: '/main/report',
          name: 'main-report',
          component: Report,
          meta: {isMain: false, isHeader: true, titleName: '전력비 절감 서비스'}
        },
        {
          path: '/main/reportSummary',
          name: 'main-report-summary',
          component: ReportSummary,
          meta: {isMain: false, isHeader: false, isFooter: false, titleName: '전력비 절감 월간 보고서'}
        },
        {
          path: '/main/reportDetail',
          name: 'main-report-detail',
          component: ReportDetail,
          meta: {isMain: false, isHeader: true, isFooter: false}
        },
        {
          path: '/main/reportDetailLow',
          name: 'main-report-detail-low',
          component: ReportDetailLow,
          meta: {isMain: false, isHeader: true, isFooter: false}
        },
        {
          path: '/main/reportUser',
          name: 'main-report-user',
          component: ReportUser,
          meta: {isMain: true, isHeader: true, isFooter: true},
          beforeEnter: async function (to, from, next) {
            if (store.getters['account/getUserData'].userType === 1) {
              return next('/main/report')
            }
            return next()
          }
        },
        {
          path: '/main/reportMiddle',
          name: 'main-report-middle',
          component: Report,
          meta: {isMain: false, isHeader: true, isFooter: false}
        },
        {
          path: '/main/message',
          name: 'main-message',
          component: Message,
          meta: {isMain: true, isHeader: true, isFooter: true}
        },
        // {
        //   path: '/main/receipt',
        //   name: 'main-receipt',
        //   component: Receipt,
        //   meta: {isMain: true, isHeader: true, isFooter: true}
        // },
        {
          path: '/mypage',
          name: 'app-mypage-index',
          component: Mypage,
          meta: {isMain: false, isHeader: true, isFooter: true, isMypage: true}
        },
        {
          path: '/mypage/notice',
          name: 'app-mypage-notice',
          component: Notice,
          meta: {isMain: false, isHeader: true, titleName: '공지사항'}
        },
        {
          path: '/mypage/noticeDetail',
          name: 'app-mypage-noticeDetail',
          component: NoticeDetail,
          meta: {isMain: false, isHeader: true, titleName: '공지사항'}
        },
        {
          path: '/mypage/faq',
          name: 'app-mypage-faq',
          component: Faq,
          meta: {isMain: false, isHeader: true, titleName: 'FAQ'}
        },
        {
          path: '/mypage/inquire',
          name: 'app-mypage-inquire',
          component: Inquire,
          meta: {isMain: false, isHeader: true, titleName: '불편사항 접수'}
        },
        {
          path: '/mypage/inquireDetail',
          name: 'app-mypage-inquireDetail',
          component: InquireDetail,
          meta: {isMain: false, isHeader: true, titleName: '불편사항 접수'}
        },
        {
          path: '/mypage/inquireForm',
          name: 'app-mypage-inquireForm',
          component: InquireForm,
          meta: {isMain: false, isHeader: true, titleName: '불편사항 접수'}
        },
        {
          path: '/mypage/modifyCompany',
          name: 'app-mypage-modifyCompany',
          component: ModifyCompany,
          meta: {isMain: false, isHeader: true, titleName: '회사 정보 수정'}
        },
        {
          path: '/mypage/modifyContact',
          name: 'app-mypage-modifyContact',
          component: ModifyContact,
          meta: {isMain: false, isHeader: true, titleName: '담당자 정보 수정'}
        },
        {
          path: '/mypage/modifyPWD',
          name: 'app-mypage-modifyPWD',
          component: ModifyPWD,
          meta: {isMain: false, isHeader: true, titleName: '비밀번호 변경'}
        },
        {
          path: '/mypage/modifyAddress',
          name: 'app-mypage-modifyAddress',
          component: ModifyAddress,
          meta: {isMain: false, isHeader: true, titleName: '소재지 변경'}
        },
        {
          path: '/mypage/pushLog',
          name: 'mypage-pushlog',
          component: PushLog,
          meta: {isMain: false, titleName: '알림 내역'}
        },
        {
          path: '/account/inquire',
          name: 'app-account-inquire',
          component: IntroInquire,
          meta: {isMain: false, isHeader: true, titleName: '도입 문의'}
        },
        {
          path: '/cert',
          name: 'app-cert',
          component: Cert,
          meta: {isMain: false, isHeader: true, titleName: '인증 서비스'}
        },
        {
          path: '/lab',
          name: 'app-lab',
          component: Lab,
          meta: {isMain: false, isHeader: true, titleName: '연구소 서비스'}
        },
        {
          path: '/lab/researchList',
          name: 'app-lab-research-list',
          component: LabResearchList,
          meta: {isMain: false, isHeader: true, titleName: '연구 일지'}
        },
        {
          path: '/lab/requestResearch',
          name: 'app-lab-request-research',
          component: LabRequestResearch,
          meta: {isMain: false, isHeader: true, titleName: '연구일지 신청'}
        },
        {
          path: '/lab/requestChange',
          name: 'app-lab-request-change',
          component: LabRequestChange,
          meta: {isMain: false, isHeader: true, titleName: '변경 신청'}
        },
        {
          path: '/lab/requestPerformance',
          name: 'app-lab-request-performance',
          component: LabRequestPerformance,
          meta: {isMain: false, isHeader: true, titleName: '실적보고 신청'}
        },
        {
          path: '/elect/select',
          name: '/app-elect-select',
          component: ElectSelectUser,
          meta: {isMain: false, isHeader: true, titleName: '회원사 선택'},
          beforeEnter: function (to, from, next) {
            // TODO 중간관리자 맞는지 검증 한번 더
            return next()
          }
        }
      ]
    }
  ]
})


window.fnBack = (isBack = true) => {
  let isModal = store.state.layout.modal.isModal
  if (isModal) {
    if ('terms-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
    if ('privacy-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
    if ('address-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
    if ('agency-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
    if ('station-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
    if ('qr-modal' === store.state.layout.modal.modalName) {
      window.fnCloseModal()
      return false
    }
  }

  const currentPath = router.history.current.path
  switch (currentPath) {
    case '/account/joinComplete':
      router.replace('/account/login')
      return false
    case '/elect/select':
      router.replace('/account/login')
      return false
  }

  if (closePaths.indexOf(nowPath) >= 0) {
    Util.nativeFinish()
  } else if (isBack) {
    router.go(-1)
  }
}

window.fnCloseModal = () => {
  let isModal = store.state.layout.modal.isModal
  let isModalAlert = store.state.layout.modalAlert.isModalAlert
  if (isModal) {
    store.commit('layout/setIsShowModal', {isShow: false})
    setTimeout(() => {
      store.commit('layout/setModal', {isModal: false, modalName: ''})
    }, 200)
    return true
  }
  if (isModalAlert) {
    store.commit('layout/setIsShowModalAlert', {isShowAlert: false})
    setTimeout(() => {
      store.commit('layout/setModalAlert', {isModalAlert: false, modalAlertName: ''})
    }, 200)
    return true
  }
  return false
}

let flag = false
router.beforeEach((to, from, next) => {
  if (window.$this !== null) {
    window.$this = null
  }
  window.fromPath = from.path
  window.toPath = to.path
  let meta = to.meta
  updateLayout(meta)
  nowPath = to.fullPath

  if (Util.isApp()) {
    if (nowPath.indexOf('account') < 0) {
      const accessToken = store.getters['account/getAccessToken']
      if (Util.isEmpty(accessToken)) {
        router.push('/account/login')
      }
    }
  }

  if (from.fullPath === '/main/message' && nowPath !== '/main/message#') {
    let step = store.getters['pageStatus/getMessageStatus']
    if (!flag && step) {
      let nextPath = nowPath
      Util.modalConfirm(ConstCode.CONFIRM_TYPE.CONFIRM, {message: '현재 페이지를 벗어나면 상담이 종료됩니다.<br>상담을 종료하시겠습니까?'}, () => {
        flag = true
        store.commit('pageStatus/setMessageStatus', false)
        setTimeout(() => {
          router.push(nextPath)
        }, 300)
      })
    } else {
      return next()
    }
  } else {
    return next()
  }
})

router.afterEach((to, from) => {
  if ((from.fullPath === '/main/message#' && to.fullPath !== '/main/message') || (from.fullPath === '/main/message' && to.fullPath !== '/main/message#')) {
    flag = false
  }
})

window.nativeSetDeviceInfo = async (deviceType, deviceId, pushToken, appVersion, os, isNew = false) => {
  // AOS 새로운 앱이 아니면 재설치 안내 메시지 노출
  // if (deviceType === '1' && !isNew) {
  //   Util.modalAlert({message: '새로운 앱이 출시 되었습니다.<br/>기존 앱 제거후 플레이스토어 에서 기업누리를 검색해 주세요.'}, () => {
  //   })
  // }

  if (Util.isEmpty(pushToken)) {
    setTimeout(() => {
      Util.nativeGetRegistrationKey('nativeSetDeviceInfo')
    }, 500)

    return false
  }

  const isManager = store.getters['account/getIsManager']
  const userData = store.getters['account/getUserData']
  if (isManager) {
    const managerData = store.getters['account/getManagerData']
    if (userData.userNo !== managerData.userNo) {
      return false
    }
  }
  await AccountSvc.resetRegistrationKey({
    userNo: Util.isEmpty(userData) ? 0 : userData.userNo,
    deviceID: deviceId,
    deviceTypeID: deviceType,
    registrationKey: pushToken
  })
  let deviceInfo = {}
  deviceInfo['deviceTypeID'] = deviceType
  deviceInfo['deviceID'] = deviceId
  deviceInfo['pushToken'] = pushToken
  deviceInfo['appVersion'] = appVersion
  deviceInfo['os'] = os

  localStorage.deviceInfo = JSON.stringify(deviceInfo)

}

window.pushCallBack = (link) => {
  router.push({path: link})
}

export default router
